/* ==========================================================================
   ATN Homepage V1.0 — Section 00: Utility Header
   Spec reference: 00_Section.docx §42 (analytics), §16 (language selector)

   Responsibilities:
   1. Push analytics events when "Send analytics events" is enabled.
   2. On mobile, shorten the GTranslate options to language codes (EN, AF, SQ)
      to mirror the existing header behaviour in main.js. Desktop keeps full
      language names.

   Events: utility_advertise_click, utility_login_click, utility_account_click,
           utility_join_click, utility_language_change

   No personal account information is sent.
   ========================================================================== */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-atn-utility-root]';
  var MOBILE_QUERY = '(max-width: 749px)';

  function deviceType() {
    var w = window.innerWidth;
    if (w <= 749) return 'mobile';
    if (w <= 1100) return 'tablet';
    return 'desktop';
  }

  function sectionIdFrom(el) {
    var wrapper = el.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : '';
  }

  /* ---- Analytics ------------------------------------------------------- */

  function send(root, eventName, params) {
    if (root.dataset.analytics !== 'true' || !eventName) return;

    var payload = Object.assign(
      {
        device_type: deviceType(),
        current_page: window.location.pathname,
        login_state: root.dataset.loggedIn === 'true' ? 'logged_in' : 'logged_out',
        section_id: sectionIdFrom(root)
      },
      params || {}
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  }

  /* ---- Mobile short language codes ------------------------------------- */
  /* Mirrors the header logic in main.js (~line 1974) but scoped to this      */
  /* section only, so the two never fight over the same nodes.                */

  function shortenSwitcher(selector) {
    // Dropdown options -> flag + CODE
    selector.querySelectorAll('.gt_option a').forEach(function (item) {
      var langCode = item.getAttribute('data-gt-lang');
      if (!langCode || item.dataset.atnShortened === 'true') return;

      var img = item.querySelector('img');
      item.innerHTML = '';
      if (img) item.appendChild(img);
      item.insertAdjacentText('beforeend', ' ' + langCode.toUpperCase());
      item.dataset.atnShortened = 'true';
    });

    // Selected label -> flag + CODE
    var selected = selector.querySelector('.gt_selected a');
    if (!selected) return;

    var currentImg = selected.querySelector('img');
    var currentActive = selector.querySelector('.gt_option a.gt_current');
    var langCode = 'EN';

    if (currentActive && currentActive.getAttribute('data-gt-lang')) {
      langCode = currentActive.getAttribute('data-gt-lang').toUpperCase();
    }

    selected.innerHTML = '';
    if (currentImg) selected.appendChild(currentImg);
    selected.insertAdjacentText('beforeend', ' ' + langCode);
  }

  function applyResponsiveLabels(selector) {
    var mql = window.matchMedia(MOBILE_QUERY);

    function apply() {
      if (mql.matches) {
        shortenSwitcher(selector);
      }
    }

    // GTranslate loads asynchronously; poll until the switcher exists.
    var tries = 0;
    var interval = setInterval(function () {
      tries += 1;
      if (selector.querySelector('.gt_selected a')) {
        apply();
        selector.classList.add('loaded');
        clearInterval(interval);
      } else if (tries > 40) {
        clearInterval(interval);
      }
    }, 300);

    // Re-apply when crossing the breakpoint.
    var onChange = function () {
      if (mql.matches) shortenSwitcher(selector);
    };
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
    } else if (mql.addListener) {
      mql.addListener(onChange);
    }
  }

  /* ---- Bind ------------------------------------------------------------ */

  function bind(root) {
    if (!root || root.dataset.atnUtilityBound === 'true') return;
    root.dataset.atnUtilityBound = 'true';

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[data-atn-utility-event]');
      if (trigger) {
        send(root, trigger.dataset.atnUtilityEvent, {
          action_label: (trigger.textContent || '').trim(),
          destination_url: trigger.getAttribute('href') || ''
        });
        return;
      }

      // GTranslate options are anchor tags; capture language change for analytics.
      var langLink = event.target.closest('.language_selector .gt_option a[data-gt-lang]');
      if (langLink) {
        send(root, 'utility_language_change', {
          selected_language: langLink.getAttribute('data-gt-lang'),
          action_label: (langLink.textContent || '').trim()
        });
      }
    });

    var selector = root.querySelector('.language_selector');
    if (selector) applyResponsiveLabels(selector);
  }

  function init(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();